import { Typography } from '@mui/material';
import { BaseDeactivationAlert } from 'features/geoEvents/components/BaseDeactivationAlert';
import { Trans } from 'react-i18next';

type FloodingDeactivationAlertProps = {
  hasEvacZones: boolean;
};

export const FloodingDeactivationAlert = (
  props: FloodingDeactivationAlertProps,
): JSX.Element => {
  const { hasEvacZones } = props;

  return (
    <BaseDeactivationAlert hasEvacZones={hasEvacZones}>
      <Typography>
        <Trans i18nKey="editGeoEvent.deactivationStarted.manual">
          Incident deactivation timer started -
          <b>Approximately 6 hours from Manual Deactivation</b>.
        </Trans>
      </Typography>
    </BaseDeactivationAlert>
  );
};
